// Kleiner Client-Cache für Ansprechpartner je Kunde (#105).
// Analog zum customerCache: die Kontaktliste eines Kunden wird einmal
// geladen und 60 s gehalten (der Stamm ändert sich selten). Liefert auch
// inaktive Kontakte mit — die Auswahl-UIs filtern selbst.
import apiService from '../services/apiService';

const TTL_MS = 60 * 1000;
const cache = new Map(); // customerId -> { fetchedAt, contacts: [...] }
const pending = new Map();

export async function getCustomerContacts(customerId) {
  if (!customerId) return [];
  const hit = cache.get(customerId);
  if (hit && Date.now() - hit.fetchedAt < TTL_MS) return hit.contacts;
  if (!pending.has(customerId)) {
    pending.set(customerId, apiService.getCustomerContacts(customerId)
      .then(resp => {
        const contacts = resp.contacts || [];
        cache.set(customerId, { fetchedAt: Date.now(), contacts });
        return contacts;
      })
      .catch(() => (cache.get(customerId)?.contacts) || [])
      .finally(() => { pending.delete(customerId); }));
  }
  return pending.get(customerId);
}

// Einzelnen Kontakt nachschlagen (für die Anzeige im Ticket-Detail).
export async function getContactById(customerId, contactId) {
  if (!customerId || !contactId) return null;
  const contacts = await getCustomerContacts(customerId);
  return contacts.find(k => k.id === contactId) || null;
}

export function invalidateContactCache(customerId = null) {
  if (customerId) cache.delete(customerId); else cache.clear();
}
